import { GameVars } from "../../../GameVars";
import { GameConstants } from "../../../GameConstants";
import { TimerLabel } from "./TimerLabel";

export class HUD extends Phaser.GameObjects.Container {

    private timerLabel: TimerLabel;
    private levelLabel: Phaser.GameObjects.BitmapText;
    private scoreLabel: Phaser.GameObjects.Text;
    private extraTimeLabel: Phaser.GameObjects.Text;
    private extraPointsLabel: Phaser.GameObjects.Text;
    private f: number;
    private markingScoreReduction: boolean;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.f = 0;
        this.markingScoreReduction = false;

        this.timerLabel = new TimerLabel(this.scene);
        this.timerLabel.x = GameConstants.GAME_WIDTH / 2 - 15;
        this.timerLabel.y = 71;
        this.add(this.timerLabel);

        this.scoreLabel = new Phaser.GameObjects.Text(this.scene, 110, this.timerLabel.y - 25 * GameVars.scaleY, GameVars.padNumberToString(GameVars.score.toString()), { fontFamily: "Sarpanch-Black", fontSize: "28px", color: "#fcff00" });
        this.scoreLabel.setOrigin(1, .5);
        this.scoreLabel.scaleY = GameVars.scaleY;
        this.scoreLabel.setShadow(0, 0, "#ff9000", 4.5, true, true);
        this.add(this.scoreLabel);

        const scoreIcon = new Phaser.GameObjects.Image(this.scene, this.scoreLabel.x + 15, this.scoreLabel.y, "texture_atlas_1", "icon_score");
        scoreIcon.setOrigin(.5);
        scoreIcon.setScale(.5, GameVars.scaleY * .5);
        this.add(scoreIcon);

        this.extraTimeLabel = new Phaser.GameObjects.Text(this.scene, GameConstants.GAME_WIDTH * 3 / 2, GameConstants.GAME_HEIGHT / 2,  "+" + GameConstants.PASSED_LEVEL_EXTRA_TIME + "s", {fontFamily: "Sarpanch-Black", fontSize: "80px", color: "#00bbfb" });
        this.extraTimeLabel.setOrigin(.5);
        this.extraTimeLabel.setShadow(0, 0, "#00bbfb", 12.5, true, true);
        this.extraTimeLabel.scaleY = GameVars.scaleY;
        this.extraTimeLabel.visible = false;
        this.add(this.extraTimeLabel);

        this.extraPointsLabel = new Phaser.GameObjects.Text(this.scene, -GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2 + 75, "+" + GameConstants.PASSED_LEVEL_EXTRA_POINTS + "points", {fontFamily: "Sarpanch-Black", fontSize: "65px", color: "#ffd71c" });
        this.extraPointsLabel.setOrigin(.5);
        this.extraPointsLabel.setShadow(0, 0, "#ffd71c", 12.5, true, true);
        this.extraPointsLabel.scaleY = GameVars.scaleY;
        this.extraPointsLabel.visible = false;
        this.add(this.extraPointsLabel);

        this.levelLabel = new Phaser.GameObjects.BitmapText(this.scene, this.timerLabel.x, 2, "sarpanch", "level: " + GameVars.currentLevel.toString(), 18);
        this.levelLabel.visible = false;
        this.levelLabel.scaleY = GameVars.scaleY;
        this.add(this.levelLabel);

        // HAY Q HACER ESTO PQ EL METODO UPDATE NO SE UTILIZA DE MANERA AUTOMATICA
        this.scene.sys.updateList.add(this);
    }

    public preUpdate(time: number, delta: number): void {

        if (this.markingScoreReduction) {

            this.f++;

            if (this.f === 40) {
                this.unMarkMinusScore();
            }
        }
    }

    public extraTime(t: number): void {

        this.updateTimer();

        this.extraTimeLabel.text = "+" + t + "s";

        this.extraTimeLabel.visible = true;
        this.extraTimeLabel.x = GameConstants.GAME_WIDTH * 3 / 2;

        this.scene.tweens.add({
            targets: this.timerLabel,
            scaleX: 1.1,
            scaleY: 1.1,
            ease: Phaser.Math.Easing.Cubic.Out,
            yoyo: true,
            duration: 150
        });

        this.scene.tweens.add({
            targets: this.extraTimeLabel,
            x: GameConstants.GAME_WIDTH / 2,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250
        });

        this.scene.tweens.add({
            targets: this.extraTimeLabel,
            x: - GameConstants.GAME_WIDTH / 2,
            ease: Phaser.Math.Easing.Cubic.Out,
            delay: 1500,
            onComplete: function (): void {
                this.extraTimeLabel.false = true;
            },
            onCompleteScope: this,
            duration: 450
        });
    }

    public extraPoints(): void {

        this.updateScore();

        this.extraPointsLabel.text = "+" + GameConstants.PASSED_LEVEL_EXTRA_POINTS + "points";

        this.extraPointsLabel.visible = true;
        this.extraPointsLabel.x = -GameConstants.GAME_WIDTH / 2;

        this.scene.tweens.add({
            targets: this.extraPointsLabel,
            x: GameConstants.GAME_WIDTH / 2,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250
        });

        this.scene.tweens.add({
            targets: this.extraPointsLabel,
            x: GameConstants.GAME_WIDTH * 3 / 2,
            ease: Phaser.Math.Easing.Cubic.Out,
            delay: 1500,
            onComplete: function (): void {
                this.extraPointsLabel.false = false;
            },
            onCompleteScope: this,
            duration: 450
        });
    }

    public updateScore(): void {

        // mirar la puntuacion que habia antes
        const scoreStr = this.scoreLabel.text;
        scoreStr.replace(",", "");
        const previousScore = parseInt(scoreStr);

        if (previousScore > GameVars.score) {
            this.markMinusScore();
        }

        this.scoreLabel.text = GameVars.padNumberToString(GameVars.formatNumber(GameVars.score));
    }

    public updateTimer(): void {

        this.timerLabel.updateTimer();
    }

    public updateLevel(): void {

        this.levelLabel.setText("level: " + GameVars.currentLevel.toString());
    }

    private markMinusScore(): void {

        this.f = 0;
        this.markingScoreReduction = true;
        this.scoreLabel.setColor("#FF0000");
        this.scoreLabel.setShadow(0, 0, "#ff0000", 4.5, true, true);
    }

    private unMarkMinusScore(): void {

        this.markingScoreReduction = false;
        this.scoreLabel.setColor("#fcff00");
        this.scoreLabel.setShadow(0, 0, "#ff9000", 4.5, true, true);
    }
}
